import Restraint from "./Restraint.js";

/**
 * Positioniert das Objekt in einem festen Abstand zur Kamera
 */
export default class CameraRestraint extends Restraint {

    constructor(options) {
        super(options);
        this.radius = (options && options.radius) || 20;
    }

    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        return ray.direction.clone().multiplyScalar(this.radius).add(ray.origin);
    }

}
